// @flow
import { useResourceFetch } from '@gandi/resource/react';

import type { FetchParams } from '@gandi/resource/redux';

import { useAppSelector } from 'src/hooks/useAppSelector';

import {
  templatesResource,
  type TemplateSummary,
} from '../../modules/cloud/resources/templates';

import { selectFetchAccountParams } from './account';
import type { FetchAccountParams } from './account';

export type FetchTemplatesParams = FetchAccountParams;

export function useTemplates(): {
  fetchTemplatesParams: FetchTemplatesParams,
  isFailureTemplates: boolean,
  isFetchingTemplates: boolean,
  isForbiddenTemplates: boolean,
  isLoadedTemplates: boolean,
  label: string,
  shouldFetchTemplates: boolean,
  templates: ?Array<TemplateSummary>,
} {
  const fetchTemplatesParams = useAppSelector(selectFetchAccountParams);
  const {
    summaries: templates,
    isFailure: isFailureTemplates,
    isFetching: isFetchingTemplates,
    isForbidden: isForbiddenTemplates,
    isLoaded: isLoadedTemplates,
    label,
    shouldFetch: shouldFetchTemplates,
  } = useResourceFetch(templatesResource, (fetchTemplatesParams: FetchParams));

  return {
    fetchTemplatesParams,
    isFailureTemplates,
    isFetchingTemplates,
    isForbiddenTemplates,
    isLoadedTemplates,
    label,
    shouldFetchTemplates,
    templates,
  };
}
